import script from "./YearsPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./YearsPicker.vue?vue&type=script&lang=ts&setup=true"

import "./YearsPicker.vue?vue&type=style&index=0&id=18114425&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18114425"]])

export default __exports__